import React from "react";

export default function BoxError() {
  return (
    <div className="load-error">
      Cannot load data . Please check your connection
    </div>
  );
}
